/**
 * Les gestes de « Mon historique de lives », ceux de l'ancienne table (`LivesHistory`) : le nom d'un
 * élève ouvre sa fiche (`student-profil`, la fiche à onglets de Mes élèves sur son Aperçu,
 * `TutorStudentProfileScreen`, par le pont de l'espace), « Voir le rapport » ouvre le rapport de la
 * séance (`r`), la croix revient — ou l'accueil (`menu`) quand la pile est vide.
 */
import { useNavigation } from "@react-navigation/native"
import { useCallback } from "react"

import { type TutorHistoryReportRow } from "../../../../adapters/tutor/Lives/tutorHistoryAdapter"
import { type UITutorHistoryReport } from "../../../types/tutorLives"
import { useBackOr } from "../../../hooks/useBackOr"

type StackNavigation = { push: (route: string, params?: object) => void }

/** La page rend les comptes-rendus qu'on lui a passés : ceux du view-model, qui portent leurs ids d'action. */
const asRow = (report: UITutorHistoryReport) => report as TutorHistoryReportRow

export function useTutorLivesHistoryState() {
    const navigation = useNavigation() as unknown as StackNavigation
    return {
        onClose: useBackOr("menu"),
        onOpenStudent: useCallback(
            (report: UITutorHistoryReport) => {
                const { studentId } = asRow(report)
                if (studentId != null) navigation.push("student-profil", { studentId, withActions: true })
            },
            [navigation]
        ),
        onOpenReport: useCallback(
            (report: UITutorHistoryReport) => {
                const { hash } = asRow(report)
                if (hash) navigation.push("r", { h: hash })
            },
            [navigation]
        ),
    }
}
